import React from 'react'
import Sidebar from '../sidebar/Sidebar'

const AdminLayout = ({ page, children }) => {
    return (
        <div className="w-full h-screen flex">
            <div>
                <Sidebar page={page}/>
            </div>
            <div className="w-full bg-gray-200 overflow-y-auto">
                {children}
            </div>
        </div>
    )
}

export default AdminLayout